import React from "react";
import { useSelector } from "react-redux";
import { Grid } from "semantic-ui-react";
import {
  getAdmin,
  getExpiredJobToReview,
  getPaidJobsUnderReview,
  getUnderReviewFreebiesJobs,
} from "../adminSelectors";
import JobPostListItem from "../../employer/components/JobPostListItem";
import sortBy from "lodash/sortBy";
import { JOB_POST_TYPE } from "../../employer/employerConstanst";

export default function ReviewJobs({
  type,
  editable = true,
  preview = true,
  stats = true,
  close = true,
}) {
  const { jobs, underReviewFreebies } = useSelector((state) => getAdmin(state));

  let jobsToList = [];
  if (type === JOB_POST_TYPE.underReview) {
    jobsToList = sortBy(
      [
        ...getPaidJobsUnderReview(jobs),
        ...getUnderReviewFreebiesJobs(underReviewFreebies),
      ],
      "dateCreated"
    );
  } else if (type === JOB_POST_TYPE.expired) {
    jobsToList = getExpiredJobToReview(jobs);
  }

  function getNewJobsForReview(jobs) {
    return jobs.filter((job) => !job.isInitialised);
  }

  function getResubmittedJobsForReview(jobs) {
    return jobs.filter((job) => job.isInitialised);
  }

  const NoJobsMessage = () => (
    <span className="manage-item-list-no-item">None</span>
  );

  const resubmittedJobsUnderReview = getResubmittedJobsForReview(jobsToList);
  const newJobsUnderReview = getNewJobsForReview(jobsToList);

  return (
    <Grid>
      <Grid.Column width={16}>
        <br />
        {type === JOB_POST_TYPE.expired && (
          <div>
            {jobsToList.length > 0 ? (
              jobsToList.map((job) => (
                <JobPostListItem
                  job={job}
                  key={job.id}
                  editable={editable}
                  preview={preview}
                  stats={stats}
                  type={type}
                  close={close}
                  isAdmin={true}
                />
              ))
            ) : (
              <span className="manage-item-list-no-item">
                No jobs under review
              </span>
            )}
          </div>
        )}
        {type === JOB_POST_TYPE.underReview && (
          <div>
            <div>
              <div className="body-blue-text semi-bold">
                Resubmitted ({resubmittedJobsUnderReview.length}):
              </div>
              <br />
              {resubmittedJobsUnderReview.length > 0 ? (
                resubmittedJobsUnderReview.map((job) => (
                  <JobPostListItem
                    job={job}
                    key={job.id}
                    editable={editable}
                    preview={preview}
                    stats={stats}
                    type={type}
                    close={close}
                    isAdmin={true}
                  />
                ))
              ) : (
                <NoJobsMessage />
              )}
            </div>
            <br />
            <div>
              <div className="body-blue-text semi-bold">
                New ({newJobsUnderReview.length}) - only approve between 8am -
                2pm:
              </div>
              <br />
              {newJobsUnderReview.length > 0 ? (
                newJobsUnderReview.map((job) => (
                  <JobPostListItem
                    job={job}
                    key={job.id}
                    editable={editable}
                    preview={preview}
                    stats={stats}
                    type={type}
                    close={close}
                    isAdmin={true}
                  />
                ))
              ) : (
                <NoJobsMessage />
              )}
            </div>
          </div>
        )}
      </Grid.Column>
    </Grid>
  );
}
